import React, { useEffect, useState } from 'react';
import { XIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { Button } from './Button';
import { Input } from './Input';
import { Select } from './Select';
import { Earning } from './EarningCard';
interface EditEarningModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (earning: Earning) => void;
  earning: Earning | null;
}
export function EditEarningModal({
  isOpen,
  onClose,
  onSave,
  earning
}: EditEarningModalProps) {
  const [amount, setAmount] = useState('');
  const [date, setDate] = useState('');
  const [type, setType] = useState<'Ladeboks' | 'Andet'>('Ladeboks');
  const [notes, setNotes] = useState('');
  useEffect(() => {
    if (earning) {
      setAmount(earning.amount.toString());
      setDate(earning.date);
      setType(earning.type);
      setNotes(earning.notes || '');
    }
  }, [earning]);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!earning || !amount) return;
    onSave({
      ...earning,
      amount: parseFloat(amount),
      date,
      type,
      notes: type === 'Andet' && notes ? notes : undefined
    });
    onClose();
  };
  if (!earning) return null;
  return <AnimatePresence data-id="element-569">
      {isOpen && <>
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 bg-black/20 backdrop-blur-sm z-40" onClick={onClose} data-id="element-570" />
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} transition={{
        type: 'spring',
        duration: 0.3
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4 overflow-y-auto" data-id="element-571">
            <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md p-6 my-8" data-id="element-572">
              <div className="flex items-center justify-between mb-6" data-id="element-573">
                <h2 className="text-2xl font-semibold text-stone-900" data-id="element-574">
                  Rediger indtjening
                </h2>
                <button onClick={onClose} className="text-stone-400 hover:text-stone-600 transition-colors" aria-label="Luk" data-id="element-575">
                  <XIcon className="w-6 h-6" data-id="element-576" />
                </button>
              </div>

              <form onSubmit={handleSubmit} className="space-y-4" data-id="element-577">
                <Input label="Beløb (kr)" type="number" step="0.01" value={amount} onChange={e => setAmount(e.target.value)} placeholder="f.eks. 8000" required data-id="element-578" />

                <Input label="Dato" type="date" value={date} onChange={e => setDate(e.target.value)} required data-id="element-579" />

                <Select label="Type" value={type} onChange={e => setType(e.target.value as 'Ladeboks' | 'Andet')} options={[{
              value: 'Ladeboks',
              label: 'Ladeboks'
            }, {
              value: 'Andet',
              label: 'Andet'
            }]} required data-id="element-580" />

                {type === 'Andet' && <motion.div initial={{
              opacity: 0,
              height: 0
            }} animate={{
              opacity: 1,
              height: 'auto'
            }} exit={{
              opacity: 0,
              height: 0
            }} transition={{
              duration: 0.2
            }} data-id="element-581">
                    <label className="block text-sm font-medium text-stone-700 mb-1.5" data-id="element-582">
                      Noter
                    </label>
                    <textarea value={notes} onChange={e => setNotes(e.target.value)} placeholder="Tilføj noter om denne indtjening" rows={3} className="w-full px-4 py-2.5 rounded-lg border border-stone-200 bg-white text-stone-900 placeholder-stone-400 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent transition-all resize-none" data-id="element-583" />
                  </motion.div>}

                <div className="flex gap-3 pt-2" data-id="element-584">
                  <Button type="button" variant="secondary" onClick={onClose} className="flex-1" data-id="element-585">
                    Annuller
                  </Button>
                  <Button type="submit" variant="primary" className="flex-1" data-id="element-586">
                    Gem ændringer
                  </Button>
                </div>
              </form>
            </div>
          </motion.div>
        </>}
    </AnimatePresence>;
}